var map = {
	"./Chulo.png": 51,
	"./X.png": 52,
	"./blackanddecker.png": 53,
	"./bostitch.png": 54,
	"./craftsman.png": 55,
	"./dewalt.png": 56,
	"./expert.png": 57,
	"./facom.png": 58,
	"./irwin.png": 59,
	"./lenox.png": 60,
	"./mac_tools.png": 61,
	"./porter_cable.png": 62,
	"./servicenet.png": 63,
	"./sidchrome.png": 64,
	"./stanley_tools.png": 27,
	"./usag.png": 65
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50;